import { Plus } from 'lucide-react';
import { useUi } from '../stores/ui.js';
import { Button } from '../ui/Button.js';

export function AddTaskButton({
  defaultProjectId,
  className,
}: {
  defaultProjectId?: string | null;
  className?: string;
}): React.ReactElement {
  const open = useUi((s) => s.openQuickAdd);
  return (
    <Button
      size="icon"
      onClick={() => open(defaultProjectId ?? null)}
      aria-label="New task"
      className={className}
    >
      <Plus size={20} aria-hidden />
    </Button>
  );
}
